import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import {
  Avatar,
  AvatarFallbackText,
  AvatarImage,
} from "@/components/ui/avatar";
import { HStack } from "@/components/ui/hstack";
import { Icon } from "@/components/ui/icon";
import { ChevronRight } from "lucide-react-native";
import { OrganizationDTO } from "@/generated/api/models";

export function RestaurantListItem(props: OrganizationDTO) {
  return (
    <HStack
      space="md"
      className="border border-background-300 rounded-lg p-4 items-center justify-between w-full"
    >
      <HStack space="xl" className="items-center">
        <Avatar>
          <AvatarFallbackText>{props.name}</AvatarFallbackText>
          <AvatarImage
            source={{
              uri: props.avatarImage || undefined,
            }}
          />
        </Avatar>
        <VStack>
          <Text className="font-semibold text-typography-900 text-lg line-clamp-1">
            {props.name}
          </Text>
        </VStack>
      </HStack>
      <Icon as={ChevronRight} />
    </HStack>
  );
}
